import { useState, useEffect } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import Swal from "sweetalert2";
import axios from "axios";
import Select from "react-select";

export default function Add_data_modal({
  select_data,
  open_update_data_modal,
  onUpdateLeave,
}) {
  const [ren, setRen] = useState(false);
  const [update_modal_data, setUpdate_modal_data] = useState(select_data);
  const [add_data_modal_Show, set_update_data_modal_Show] = useState(false);
  const [autocomplete, setAutocomplete] = useState(null);
  const [errors, setErrors] = useState({});
  const [users, setUsers] = useState([]);
  const [clients, setClients] = useState([]);
  const [generalstafftypes, setGeneralstafftypes] = useState([]); // New state for general staff types

  useEffect(() => {
    if (select_data) {
      setUpdate_modal_data({
        ...select_data,
        id_client: select_data.id_client?._id || "",
        id_generalStaffType: select_data.id_generalStaffType?._id || "",
      });
    }
  }, [select_data, clients, generalstafftypes]);

  useEffect(() => {
    set_update_data_modal_Show(open_update_data_modal.modal_open);
  }, [open_update_data_modal]);

  const handleClose = () => {
    set_update_data_modal_Show(false);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setUpdate_modal_data((prevData) => ({
      ...prevData,
      [name]: value, // Set value directly instead of object
    }));
  };
  useEffect(() => {
    const fetchClients = async () => {
      try {
        const token = localStorage.getItem("token");
        if (!token) {
          console.error("No token found");
          return;
        }
        const response = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/api/v1/clients`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        setClients(response.data.clients);
      } catch (error) {
        console.error("Error fetching client:", error);
        setClients([]);
      }
    };
    const fetchGeneralstafftypes = async () => {
      const token = localStorage.getItem("token");
      if (!token) {
        console.error("No token found");
        return;
      }
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/api/v1/general-staff-types`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        setGeneralstafftypes(response.data.generalStaffTypes || []);
      } catch (error) {
        console.error("Error fetching general staff types:", error);
      }
    };
    fetchGeneralstafftypes();
    fetchClients();
  }, []);
  const validateForm = () => {
    const newErrors = {};
    if (!update_modal_data.id_client)
      newErrors.id_client = "Client Id is required";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleUpdate = async () => {
    if (!validateForm()) {
      return;
    }

    const token = localStorage.getItem("token");
    if (!token) {
      Swal.fire("Unauthorized!");
      return;
    }

    try {
      const { _id } = update_modal_data;
      if (!_id) {
        throw new Error("ID is not defined");
      }

      const formData = new FormData();
      formData.append(
        "id_generalStaffType",
        update_modal_data.id_generalStaffType
      );
      formData.append("wfhBalance", update_modal_data.wfhBalance);
      formData.append(
        "casualLeaveBalance",
        update_modal_data.casualLeaveBalance
      );
      formData.append("weekendPolicy", update_modal_data.weekendPolicy);
      formData.append("description", update_modal_data.description);
      formData.append("id_client", update_modal_data.id_client);

      formData.append("PF", update_modal_data.PF);
      const response = await axios.put(
        `${process.env.REACT_APP_BASE_URL}/api/v2/leave-restriction/${_id}`,
        formData,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.data.success) {
        Swal.fire("Update success", "", "success");
        onUpdateLeave(update_modal_data); // Update locally
        setRen(!ren); // Trigger rerender if necessary
      } else {
        Swal.fire("Update failed", "", "error");
      }

      set_update_data_modal_Show(false); // Close modal on success or failure
    } catch (error) {
      Swal.fire("Update failed", "", "error");
      console.error("Error updating salary:", error);
    }
  };
  const onLoad = (autoComp) => {
    setAutocomplete(autoComp);
  };

  const handleClientChange = (selectedOptions) => {
    const clientIds = selectedOptions
      ? selectedOptions.map((option) => option.value)
      : [];

    setUpdate_modal_data((prevData) => ({
      ...prevData,
      id_client: clientIds,
    }));
  };
  return (
    <>
      <Modal show={add_data_modal_Show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Leave Restriction </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mb-3">
              <Form.Label>General Staff Type *</Form.Label>
              <select
                name="id_generalStaffType"
                className="form-control"
                value={update_modal_data.id_generalStaffType || ""}
                onChange={handleChange}
              >
                <option value="">Select Staff Type</option>
                {Array.isArray(generalstafftypes) &&
                  generalstafftypes.map((generalstafftype) => (
                    <option
                      key={generalstafftype._id}
                      value={generalstafftype._id}
                    >
                      {generalstafftype.name}
                    </option>
                  ))}
              </select>
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Client *</Form.Label>
              <Select
                name="id_client"
                defaultValue={update_modal_data.id_client || ""}
                options={clients.map((client) => ({
                  value: client._id,
                  label: client.name,
                }))}
                isMulti
                onChange={handleClientChange}
                className="basic-multi-select"
                classNamePrefix="select"
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Casual Leave Balance </Form.Label>
              <Form.Control
                type="number"
                name="casualLeaveBalance"
                value={update_modal_data.casualLeaveBalance || ""}
                onChange={handleChange}
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>WFH Balance </Form.Label>
              <Form.Control
                type="number"
                name="wfhBalance"
                value={update_modal_data.wfhBalance || ""}
                onChange={handleChange}
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Weekend Policy *</Form.Label>
              <Form.Select
                name="weekendPolicy"
                value={update_modal_data.weekendPolicy || "Sunday"}
                onChange={handleChange}
              >
                <option value="None">None</option>
                <option value="Sunday">Sunday</option>
                <option value="Saturday-Sunday">Saturday-Sunday</option>
              </Form.Select>
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Description </Form.Label>
              <Form.Control
                type="text"
                name="description"
                value={update_modal_data.description || ""}
                onChange={handleChange}
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          <Button
            variant="primary"
            className="btn btn-sm"
            onClick={handleUpdate}
          >
            Update Leave Restriction
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
